module.exports = __webpack_public_path__ + "static/media/paint-tool.45597e2a.svg";